<template>
  <font-awesome-icon class="fa-icons" icon="robot"></font-awesome-icon>
</template>
